import type { QueryFilterConfig } from '@/types/common/table-config.type';
import { RoleEnum } from '@/types/enums/role.enum';

export const query: QueryFilterConfig = objFilter => {
    return {
        getFilterByRoleCustomer: {
            id: 'getFilterByRoleCustomer',
            inputType: 'input',
            key: 'customerId',
            operator: '=',
            value: objFilter.userId,
            includeRoles: [RoleEnum.CUSTOMER],
        },
        getFilterByRoleKTV: {
            id: 'getFilterByRoleKTV',
            inputType: 'input',
            key: 'technicalId',
            operator: '=',
            value: objFilter.userId,
            includeRoles: [RoleEnum.KTV],
        },
    };
};
